import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h3`
  font-family: aria;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  color: #333;
`;

export const Price = styled.span`
  font-family: aria;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  color: #333;
`;
